import { Task } from '@/api';
import { useMyCompanyUser } from '@/companies/hooks';
import { isTeamAdminOrGuardian } from '@/companies/util/team-roles';
import { isCompanyOwnerOrAdmin } from '@/companies/util/company-roles';

type TaskPermissions = {
    canAddNote: boolean;
    canAssign: boolean;
    canResolve: boolean;
};

const defaultPermissions: TaskPermissions = {
    canAddNote: false,
    canAssign: false,
    canResolve: false
};

export function useTaskPermissions(task: Task): TaskPermissions {
    const myCompanyUser = useMyCompanyUser();

    if (!myCompanyUser) {
        console.log('No company user found for task permissions');
        return defaultPermissions;
    }

    const teamPermissions = myCompanyUser.teams.find(
        (team) => team.teamId === task.team.id
    );

    if (!teamPermissions) {
        console.log('No team permissions found for task permissions');
        return defaultPermissions;
    }

    const canManageTeamTasks =
        isCompanyOwnerOrAdmin(myCompanyUser) ||
        isTeamAdminOrGuardian(teamPermissions);

    const canAddNote =
        canManageTeamTasks || task.user?.id === myCompanyUser.userId;
    const canAssign = canManageTeamTasks;
    const canResolve = canManageTeamTasks;

    return {
        canAddNote,
        canAssign,
        canResolve
    };
}
